define('loadUrl', function(require, exports, module) {
    function $loadUrl(o) {
        o.element = o.element || 'script';
        var el = document.createElement(o.element);
        el.charset = o.charset || 'utf-8';
        o.onBeforeSend&&o.onBeforeSend(el);//发请求之前调用的函数
        el.onload = el.onreadystatechange = function() {
            if(/loaded|complete/i.test(this.readyState) || navigator.userAgent.toLowerCase().indexOf("msie") == -1) {
                o.onload&&o.onload();//
                clear();
            }
        };
        el.onerror = function(){
            clear();
        };
        el.src = o.url;
        document.getElementsByTagName('head')[0].appendChild(el);

        function clear(){
            if(!el){return ;}
            el.onload = el.onreadystatechange = el.onerror = null;
            el.parentNode&&(el.parentNode.removeChild(el));
            el = null;
        }
    }
    exports.get = $loadUrl;
});


// WEBPACK FOOTER //
// ./../common/js/loadUrl.js